<div class="container-fluid container-fluid--normal">
    <div>
        <h1>Style guide</h1>
        <!--<h1>{{ 'setup_styling' | label: 'setup_styling' | async | capitalizeFirstLetter }}</h1>-->
    </div>

    <div class="h2-content">
        <h2>Eerste div-tag van een pagina/component</h2>
        <p>
            Elke pagina start met een div-tag met class="container-fluid".
            <br>
            Er wordt een tweede klasse toegevoegd:
        </p>
        <ul class="ul--disc">
            <li>container-fluid--normal: voor een standaardpagina (bv. een instellingenpagina)</li>
            <li>container-fluid--dashboard: voor een dashboard (bv. kwalificatiedashboard of home)</li>
        </ul>
    </div>

    <div class="h2-content">
        <h2>Paginatitel met h1-tag</h2>
        <p>
            Vervolgens wordt er een div-tag voorzien zonder bijkomende klasse waarbinnen een h1-tag wordt voorzien.
            <br>
            Deze h1-tag is de titel van de pagina, dewelke je meestal kan overnemen uit de navigatiestructuur.
            <br>
            Maak hiervoor een tblLabelsCommon aan indien nodig, want tblMenuLabels kan je niet gebruiken.
        </p>
    </div>

    <div class="h2-content">
        <h2>Onderdelen met h2-tag</h2>
        <p>
            Elk onderdeel wordt gestart met een div-tag met class="h2-content".
            <br>
            Hierna volgt een titel van het onderdeel met een h2-tag, gevolgd door een p-tag als subtitel of als woordje
            uitleg.
        </p>
    </div>

    <div class="h2-content">
        <h2>Subonderdelen per row en in kolommen met col, gevolgd door een h3-tag</h2>
        <p>
            Je kan bijkomende subonderdelen maken door te starten met een div-tag met class="row".
            <br>
            Dan volgt eventueel een div-tag met class="col-x" en vervolgens de h3-tag als titel van het subonderdeel.
        </p>

        <div class="row">
            <div class="col-4">
                <h3>Opsommingen met ul</h3>

                <ul class="ul--disc">
                    <li>Gebruik een class="ul--disc" voor dit opsommingsteken</li>
                    <li>In styles.scss kan je bijkomende versies toevoegen indien nodig</li>
                    <li>Bijvoorbeeld .ul--circle toevoegen voor een leeg bolletje</li>
                </ul>
            </div>

            <div class="col-4">
                <h3>Bootstrap kolommen</h3>

                <ul class="ul--disc">
                    <li>Bootstrap werkt met kolommen gebaseerd op een grid van 12</li>
                    <li>col-12 = 1 kolom over de hele breedte van een row</li>
                    <li>col-4 = 3 kolommen van gelijke breedte</li>
                    <li>Je kan werken met halfjes ook indien gewenst (bv. col-1.5), wat handig is nesting van kolommen
                    </li>
                </ul>
            </div>

            <div class="col-4">
                <h3>Checkboxen (manueel)</h3>

                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkbox1" />
                    <label class="form-check-label" for="checkbox1">Elke checkbox start met een div-tag met
                        class="form-check".</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkbox2" />
                    <label class="form-check-label" for="checkbox2">Hierin zet je twee items:</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="checkbox3" />
                    <label class="form-check-label" for="checkbox3">Een input-tag met class="form-check-input",
                        type="checkbox" en id="unieke_naam"</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="checkbox4" />
                    <label class="form-check-label" for="checkbox4">Een label-tag met class="form-check-label" en
                        for="unieke_naam"</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkbox5" />
                    <label class="form-check-label" for="checkbox5">Wil je werken met inspringingen?</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="checkbox6" />
                    <label class="form-check-label" for="checkbox6">Voeg aan de buitenste div-tag een bijkomende klasse
                        "form-check--sub-1"</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="checkbox7" />
                    <label class="form-check-label" for="checkbox7">Deze speciale klasse vind je terug in
                        forms.scss</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkbox8" />
                    <label class="form-check-label" for="checkbox8">Zorg ervoor dat de id op de input en de for op het
                        label gelijk zijn!</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkbox9" />
                    <label class="form-check-label" for="checkbox9">Anders kan je de checkbox niet aan/afvinken door te
                        klikken op de tekst!</label>
                </div>
            </div>
        </div>
    </div>

    <div class="h2-content">
        <h2>Nog uit te werken in style-guide</h2>
        <p>Radio buttons: zie <a href="https://localhost/framework/tasksettings?menuItem=561"
                target="_blank">Taakinstellingen</a> </p>
        <p>Radio buttons/checkboxen gegroepeerd met een p-tag boven: zie <a
                href="https://localhost/framework/settings/company-styling?menuItem=564"
                target="_blank">Stylinginstellingen</a> </p>
        <p>Checkboxen dynamisch ophalen + (un)check all: zie <a
                href="https://localhost/framework/tasksettings?menuItem=561" target="_blank">Taakinstellingen</a> </p>
        <p>Select/dropdowns als instellingen: zie <a href="https://localhost/projects/settings-hr?menuItem=647"
                target="_blank">Instellingen projecten</a> </p>
        <p>Textarea (tekstveld over de volledige breedte van het scherm): zie <a
                href="https://localhost/projects/customers/settings-hr?menuItem=648" target="_blank">Instellingen
                Projecten > Klanten</a> </p>
        <p>Cards: zie <a href="https://localhost/framework/tasksettings?menuItem=561"
                target="_blank">Taakinstellingen</a> </p>
        <p>Klasse form-field voor spatie onder/boven formulieren/inputvelden: zie <a
                href="https://localhost/framework/settings/company-styling?menuItem=564"
                target="_blank">Stylinginstellingen</a> </p>
        <p>Inputvelden (incl. placeholder en zoeken... eronder): zie <a
                href="https://localhost/personnel-files/gdpr-export?menuItem=559" target="_blank">GDPR Export</a> </p>
        <p>Table - normale variant: zie hieronder in styleguide met extra klasse table-details--normal</p>
        <p>Table - widget variant: zie MW Dashboard in widget Kennisdomeinen</p>
        <p>Opslaan knop vs knop "Bestand uploaden": zie <a
                href="https://localhost/framework/settings/company-styling?menuItem=564"
                target="_blank">Stylinginstellingen</a> </p>
        <p>Meerdere knoppen naast elkaar: Opslaan knop & Annuleren knop: zie <a
                href="https://localhost/framework/settings/localhrmenusettings?lhrid=3" target="_blank">Local HR fiche:
                tabblad Menu</a> </p>
    </div>

    <div class="h2-content">
        <h2>Titel per onderdeel: h2-tag</h2>
        <p>Elk h2-onderdeel wordt omvat door een div-tag met class="h2-content".</p>
        <h3>H3: Subtitel (bv. bij taakdetails)</h3>

        <p>Standaard tekst <br /> met interlinie. Met woorden in het <strong>bold</strong> of in het <em>italic</em>
        </p>

        <br>

        <p class="ellipsis w-100">
            Tekst met ellipsis achteraan de lijn (...). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
            volutpat purus in elit sodales, eu
            commodo sapien faucibus. Aenean at ...
        </p>

    </div>

    <hr class="mt-5 mb-5">

    <div class="row">
        <div class="col-12">
            <h2>Form</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="mb-3">
                <label for="code" class="form-label">
                    Tekstveld
                </label>
                <div class="p-0">
                    <input type="text" name="code" id="code" class="form-control" />
                </div>
            </div>

            <div class="mb-3">
                <label for="remarks" class="form-label">
                    Textarea
                </label>
                <div class="p-0">
                    <textarea name="remarks" id="remarks" class="form-control"></textarea>
                </div>
            </div>

            <div class="mb-3">
                <label for="test" class="form-label">
                    Dropdownlist
                </label>
                <div class="p-0">
                    <select name="test" id="test" class="form-control">
                        <option>Optie 1</option>
                        <option>Optie 2</option>
                        <option>Optie 3</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="mt-3 mb-4">
                <label for="" class="mb-3">
                    Vertalingen en andere tabs
                </label>
                <ul ngbNav #nav="ngbNav" class="translations nav-tabs">
                    <li ngbNavItem="translation1">
                        <a ngbNavLink>
                            <i class="fas fw fa-globe"></i>
                            NL
                        </a>
                        <ng-template ngbNavContent>
                            <div class="p-2 ps-4 pe-4 tab-container">
                                <div class="mb-3">
                                    <div class="">
                                        <label class="" for="name1">
                                            Vertaalbaar tekstveld
                                        </label>
                                        <div class="p-0">
                                            <input type="text" id="name1" name="name1" required class="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="description1">
                                        Vertaalbare textarea
                                    </label>
                                    <textarea id="description1" name="description1" class="form-control"></textarea>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li ngbNavItem="translation2">
                        <a ngbNavLink>
                            <i class="fas fw fa-globe"></i>
                            FR
                        </a>
                        <ng-template ngbNavContent>
                            <div class="p-2 ps-4 pe-4 tab-container">
                                <div class="mb-3">
                                    <div class="">
                                        <label class="" for="name1">
                                            Vertaalbaar tekstveld
                                        </label>
                                        <div class="p-0">
                                            <input type="text" id="name1" name="name1" required class="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="description1">
                                        Vertaalbare textarea
                                    </label>
                                    <textarea id="description1" name="description1" class="form-control"></textarea>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li ngbNavItem="translation3">
                        <a ngbNavLink>
                            <i class="fas fw fa-globe"></i>
                            EN
                        </a>
                        <ng-template ngbNavContent>
                            <div class="p-2 ps-4 pe-4 tab-container">
                                <div class="mb-3">
                                    <div class="">
                                        <label class="" for="name1">
                                            Vertaalbaar tekstveld
                                        </label>
                                        <div class="p-0">
                                            <input type="text" id="name1" name="name1" required class="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="description1">
                                        Vertaalbare textarea
                                    </label>
                                    <textarea id="description1" name="description1" class="form-control"></textarea>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li ngbNavItem="translation4">
                        <a ngbNavLink>
                            <i class="fas fw fa-globe"></i>
                            DE
                        </a>
                        <ng-template ngbNavContent>
                            <div class="p-2 ps-4 pe-4 tab-container">
                                <div class="mb-3">
                                    <div class="">
                                        <label class="" for="name1">
                                            Vertaalbaar tekstveld
                                        </label>
                                        <div class="p-0">
                                            <input type="text" id="name1" name="name1" required class="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="description1">
                                        Vertaalbare textarea
                                    </label>
                                    <textarea id="description1" name="description1" class="form-control"></textarea>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="nav"></div>
            </div>
        </div>

        <div class="col-12 mt-3">
            <button type="button" class="btn btn-progreso" (click)="getToastr()">Toastr</button>
            <button type="button" class="btn btn-progreso ms-2" (click)="getToastrInfo()">Toastr info</button>
            <button type="button" class="btn btn-progreso ms-2" (click)="getToastrError()">Toastr error</button>
        </div>

        <div class="col-12 mt-3">
            <button type="button" class="btn btn-progreso" (click)="openModal(modal)">Modal</button>
        </div>
    </div>

    <hr class="mt-5 mb-5">

    <div class="row">
        <div class="col-12">
            <h2>List</h2>
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-md-6 col-sm-12">
            <div class="filter">
                <div class="row">
                    <div class="col-12">
                        <h3>Blok filter (i.p.v. tabel rij filter)</h3>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="mb-3">
                            <label class="form-label" for="femployee">Filter veld</label>
                            <input type="input" class="form-control" id="femployee">
                        </div>

                        <div class="mb-3">
                            <label class="form-label" for="femployee">Filter veld</label>
                            <input type="input" class="form-control" id="femployee">
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="mb-3">
                            <label class="form-label" for="femployee">Filter veld</label>
                            <input type="input" class="form-control" id="femployee">
                        </div>

                        <label class="form-label" for="showExecuted"></label>
                        <div class="mb-3 form-check">
                            <input type="checkbox" class="form-check-input" id="showExecuted">
                            <label class="form-check-label" for="showExecuted">&nbsp;Filter check</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4">
            <button class="btn btn-progreso" type="button">
                <i class="fas fa-fw fa-plus"></i> Toevoegen
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="table-responsive shadow">
                <table class="table table-details table-details--normal table-hover">
                    <thead>
                        <tr>
                            <th>
                                Kolomkop
                                <i class="fas fa-long-arrow-alt-up"></i>
                            </th>
                            <th>
                                Kolomkop
                                <i class="fas fa-long-arrow-alt-down"></i>
                            </th>
                            <th>
                                Kolomkop
                            </th>
                            <th>
                                Kolomkop
                            </th>
                            <th>
                                Kolomkop
                            </th>
                            <th class="text-end" style="width: 90px;">
                                Kolomkop
                            </th>
                            <th class="icon-col"></th>
                            <th class="icon-col"></th>
                        </tr>
                        <tr class="filterRow">
                            <th>
                                <input id="code" type="text" class="form-control" placeholder="filter tekst"
                                    style="width: 100px" />
                            </th>
                            <th>
                                <select class="form-control no-outline" id="status" style="width: 110px">
                                    <option [ngValue]="null">
                                        -- kies optie --
                                    </option>
                                    <option> Optie 1 </option>
                                    <option> Optie 2 </option>
                                    <option> Optie 3 </option>
                                </select>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-primary">Optie 1</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="99" [whoKind]="3" [width]="22"
                                        [text]="'Stefaan Christiaens'"></app-profile-picture>
                                    <div class="name ms-3">Stefaan Christiaens</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-success">Succes</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 1750,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-danger">Danger</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-warning">Warning</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-info">Info</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-success">Success</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>

                        <tr>
                            <td>
                                <div class="align-items-center d-flex">
                                    <app-profile-picture [whoId]="1" [whoKind]="3" [width]="22"></app-profile-picture>
                                    <div class="name ms-3">Dirk Venters</div>
                                </div>
                            </td>
                            <td> <span class="badge text-bg-success">Success</span> </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td> Inhoud </td>
                            <td class="text-end"> &euro; 965,00 </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-edit text-secondary"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <a class="cursor-pointer fs-5">
                                    <i class="far fa-trash-alt text-danger"></i>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-end"><b>Footer totaal:</b></td>
                            <td class="text-end"><b>&euro; 965,00</b></td>
                            <td></td>
                        </tr>
                    </tbody>
                    <!-- NO FOOTER BECAUSE OF LAYOUT 
                    <tfoot>
                        
                    </tfoot> -->
                </table>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <ngb-pagination [page]="1" [pageSize]="15" [collectionSize]="50"></ngb-pagination>
            </div>
        </div>
    </div>

    <hr class="mt-5 mb-5">

    <div class="row">
        <div class="col-12">
            <h2>Instellingen</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-3">
                    <h3>Algemeen</h3>
                    <div class="form-check mb-2">
                        <input type="checkbox" class="form-check-input" id="cbxs1" />
                        <label class="form-check-label" for="cbxs1">Standaard setting</label>
                    </div>
                    <div class="form-check mb-2">
                        <input type="checkbox" class="form-check-input" id="cbxs2" />
                        <label class="form-check-label" for="cbxs2">Standaard setting</label>
                    </div>
                    <div class="form-check mb-2">
                        <input type="checkbox" class="form-check-input" id="cbxs3" [disabled]="true" />
                        <label class="form-check-label" for="cbxs3">Disabled setting</label>
                    </div>

                    <div class="mb-3 row">
                        <label for="numbers" class="col-sm-10 col-form-label">
                            Inputveld numeriek
                        </label>
                        <div class="col-sm-2">
                            <input type="text" maxlength="3" required class="form-control" id="numbers"
                                inputmode="numeric" pattern="[0-9]*" appDigitOnly />
                        </div>
                    </div>

                    <div class="mb-3 row">
                        <label for="texts" class="col-sm-6 col-form-label">
                            Inputveld tekst
                        </label>
                        <div class="col-sm-6">
                            <input type="text" equired class="form-control" id="texts" />
                        </div>
                    </div>
                </div>

                <div class="col-3">
                    <h3>Bullet points</h3>
                    <div>
                        <ul class="ul--disc">
                            <li>Coffee</li>
                            <li>Tea</li>
                            <li>Milk</li>
                        </ul>
                    </div>
                </div>

                <h3 class="mt-4">Met cards voor structuur per facet</h3>

                <div id="container-3">
                    <div class="pb-3 pe-3">
                        <div class="card">
                            <div class="card-header progreso-primary">
                                <span>Titel van facet</span>
                            </div>
                            <div class="card-body">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx1" />
                                    <label class="form-check-label" for="cbx1">Facet checkbox</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx2" />
                                    <label class="form-check-label" for="cbx2">Facet checkbox</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx3" />
                                    <label class="form-check-label" for="cbx3">Facet checkbox</label>
                                </div>

                                <div class="mb-3 row">
                                    <label for="number" class="col-sm-10 col-form-label">
                                        Inputveld numeriek
                                    </label>
                                    <div class="col-sm-2">
                                        <input type="text" maxlength="3" required class="form-control" id="number"
                                            inputmode="numeric" pattern="[0-9]*" appDigitOnly />
                                    </div>
                                </div>

                                <div class="mb-3 row">
                                    <label for="text" class="col-sm-6 col-form-label">
                                        Inputveld tekst
                                    </label>
                                    <div class="col-sm-6">
                                        <input type="text" equired class="form-control" id="text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pb-3 pe-3">
                        <div class="card">
                            <div class="card-header progreso-primary">
                                <span>Titel van facet</span>
                            </div>
                            <div class="card-body">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx1" />
                                    <label class="form-check-label" for="cbx1">Facet checkbox</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx2" />
                                    <label class="form-check-label" for="cbx2">Facet checkbox</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="cbx3" />
                                    <label class="form-check-label" for="cbx3">Facet checkbox</label>
                                </div>

                                <div class="mb-3 row">
                                    <label for="number" class="col-sm-10 col-form-label">
                                        Inputveld numeriek
                                    </label>
                                    <div class="col-sm-2">
                                        <input type="text" maxlength="3" required class="form-control" id="number"
                                            inputmode="numeric" pattern="[0-9]*" appDigitOnly />
                                    </div>
                                </div>

                                <div class="mb-3 row">
                                    <label for="text" class="col-sm-6 col-form-label">
                                        Inputveld tekst
                                    </label>
                                    <div class="col-sm-6">
                                        <input type="text" equired class="form-control" id="text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <input type="button" class="btn btn-progreso mt-3" value="Save knop" />
                </div>
            </div>
        </div>
    </div>

    <hr class="mt-5 mb-5">

</div>

<ng-template #modal let-modal>
    <div class="modal-header">
        <h2 class="modal-title">Hi there!</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Hello, stranger!</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-progreso" (click)="modal.close('Close click')">Opslaan</button>
        <button type="button" class="btn btn-light" (click)="modal.dismiss('Close click')">Annuleer</button>
    </div>
</ng-template>